const ContentType = Object.freeze({
  article: 'article',
  job: 'job',
  homepage: 'homepage',
  templatePageWithBanner: 'templatePageWithBanner',
  templatePageInnovation: 'templatePageInnovation',
  templateProduct: 'templateProduct',
  templatePageCareers: 'templatePageCareers',
  templateLocation: 'templateLocation',
  templateArticle: 'templateArticle',
  contentDocument: 'contentDocument',
  pageContact: 'pageContact',
  templatePageStory: 'templatePageStory',
})

export default ContentType
